import Vue from "vue";
import Vuex from "vuex";
import user from "./user";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    classify_id: "",
    patchOverdue: 0,
  },
  getters: {},
  mutations: {
    setClassifyId(state, val) {
      state.classify_id = val;
    },
    setPatchOverdue(state, val) {
      state.patchOverdue = Number(val) || 0;
    },
  },
  actions: {},
  modules: {
    user,
  },
});
